import * as React from "react";
import styled from "../../styled/index";
import { CS } from "../../styles/index";
import { RotateLoader } from "../loaders/rotate/index";
const LoaderWrapper = styled("div") `
    ${CS.flex.center};
    transition: 0.4s all;
    cursor: wait;
    z-index: 5;
    border-radius: 3px;
    background: ${(props) => props.boxStyle === 'classic' ? "rgba(0,0,0, 0.13)" : ""} ;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: ${(props) => props.active ? "1" : "0"};
    visibility: ${(props) => props.active ? "visible" : "hidden"};
    > div > div {
      z-index: 10;
      background-color: #ee5252;
    }
`;
// <ScaleLoader color={"#ee5252"} height={35} width={4} margin="3px" radius={10}/>
// <SyncLoader size={15}/>
// <RotateSpinLoader size={10} duration={1} color="#ee5252"/>
export const Loader = (props) => (React.createElement(LoaderWrapper, Object.assign({}, props),
    React.createElement(RotateLoader, null)));
//# sourceMappingURL=loader.js.map